import { factory, getResponseCamelization } from '@repo-level/core-front';
import { buildCmsUrl, CMSApiBase, CMSImageBase, getResponseCMS } from './base';
import { isCMSV3 } from 'helpers/conf';

export interface MobileAppApi extends CMSApiBase {
  showIos: boolean;
  showAndroid: boolean;
  iosLink?: string;
  androidApk?: CMSImageBase;
}

export const mobileAppV3 = factory((r) => () =>
  r<MobileAppApi>('get', buildCmsUrl({ path: 'mobile-app' }))
);

export const mobileAppV4 = factory((r) => () =>
  r<MobileAppApi>(
    'get',
    buildCmsUrl({ path: 'mobile-app', additionalParams: { populate: 'deep' } }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const mobileApp = isCMSV3 ? mobileAppV3 : mobileAppV4;
